export const MonotoneMinAudioPlayerHeight = 130;
